exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dialog{position:fixed;top:0;left:0;right:0;bottom:0;margin:auto}.menutree{margin-top:28px}.bread{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-bb43bedc!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/views/menu/MenuTree.vue
// module id = 613
// module chunks = 2